"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedDrinks = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Stats.Schema';
const EnhancementCount = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Consumable subset id',
    }),
    count: effect_1.Schema.propertySignature(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())).annotations({
        description: 'How many entries in params.enhancements named this id. One event can add more than one, and a missing subsetId is counted as "undefined".',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.EnhancementCount`,
});
/**
 * Counts of enhanced drink dispenses. Returned as `data` itself, not under `items`.
 * `enhancements` counts entries, not events.
 */
exports.EnhancedDrinks = effect_1.Schema.Struct({
    eventCount: effect_1.Schema.propertySignature(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())).annotations({
        description: 'How many drinkDispensed events had comp.enhanced set',
    }),
    enhancements: effect_1.Schema.Array(EnhancementCount),
}).annotations({
    identifier: `${exports.NAMESPACE}.EnhancedDrinks`,
});
//# sourceMappingURL=schema.js.map